import { colorsPalettes, mixins } from "@similarweb/styles";
import OptionsMenu from "app/pages/sales-intelligence/common-components/options-menu/OptionsMenu/OptionsMenu";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

// TODO this component is also used in enrichment sub-module, possible solution - have SectionName under SI components
export const StyledListSectionName = styled.h2`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon["400"])};
    margin: 0;
    user-select: none;
`;

export const StyledOptionsMenu = styled(OptionsMenu)`
    padding-right: 16px;
`;

export const StyledListSectionBody = styled(FlexRow)`
    flex-wrap: wrap;
    column-gap: 20px;
    margin-top: 8px;
    row-gap: 16px;
`;
